import React from 'react';
import { parseMoney, fmtMoneyInput } from './data.jsx';

/* ============================================================
   MoneyInput — a THB amount field that survives how people type
   ============================================================ */
// Plain text input (decimal keypad on mobile) instead of type="number":
// Safari/iOS let a supplier type "45,000.00" into a number input and then
// report value "" for it, which is how the invoice form ended up showing
// ฿0 and refusing to submit. The raw text stays in form state so what they
// typed is what they see; it is tidied to "45,000.00" on blur. Read it back
// with parseMoney(), never Number().
export function MoneyInput({ value, onChange, className = 'input', style, onBlur, ...rest }) {
  const text = value == null ? '' : String(value);
  const invalid = text.trim() !== '' && !Number.isFinite(parseMoney(text));
  return (
    <input
      {...rest}
      className={className}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={text}
      onChange={onChange}
      onBlur={(e) => {
        const n = parseMoney(e.target.value);
        if (Number.isFinite(n)) onChange?.({ target: { value: fmtMoneyInput(n) } });
        onBlur?.(e);
      }}
      aria-invalid={invalid || undefined}
      style={invalid ? { ...(style || {}), borderColor: 'var(--danger)' } : style}
    />
  );
}
